import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgMailOpen = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12.485 3.323a.75.75 0 0 0-.634-.005L2.687 7.52a.75.75 0 0 0-.437.682V19c0 .414.336.75.75.75h18a.75.75 0 0 0 .75-.75V8.202a.75.75 0 0 0-.428-.678zm7.56 5.255-7.888-3.75-8.192 3.756 7.547 4.847q.03.019.056.04a.7.7 0 0 0 .432.143.7.7 0 0 0 .432-.143l.056-.04zM3.75 10.228v8.022h16.5v-8.021l-6.926 4.447c-.38.287-.848.438-1.324.438s-.943-.151-1.324-.438z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgMailOpen;
